import VueRouter from 'vue-router';
const { isNavigationFailure, NavigationFailureType } = VueRouter;

export default {
  methods: {
    async replaceRoute(name, params = {}) {
      if (this.$route.name === name) return;

      await this.$router.replace({ name, params }).catch(failure => {
        if (!isNavigationFailure(failure, NavigationFailureType.cancelled)) {
          throw failure;
        }
      });
    },
  },
};
